import {NgModule} from '@angular/core';
import {PurchaseOrderRoutingModule} from './purchase-order-routing.module';

@NgModule({
  imports: [
    PurchaseOrderRoutingModule
  ]
})
export class PurchaseOrderModule {
}


